import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { takeUntil, takeWhile } from 'rxjs/operators';
import { interval } from 'rxjs';

import * as moment from 'moment';

@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"],
})
export class ConfirmDialogComponent implements OnInit {
  showTimer: boolean;
  timer: string;
  confirmText: string = "";
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    if (!!this.data.timer && !isNaN(this.data.timer)) {
      const timer = this.data.timer - 1000;
      this.showTimer = true;
      this.updateTimer(timer);
      this.updateTimerText(timer);
    }
  }

  private updateTimer(timer: number): void {
    interval(1000)
      .pipe(takeWhile(() => timer > 0))
      .subscribe(() => {
        timer -= 1000;
        this.updateTimerText(timer);
      });
  }

  private updateTimerText(timer: number): void {
    this.timer = moment
      .utc(moment.duration(timer, "milliseconds").as("milliseconds"))
      .format("mm:ss");
  }
  get confirmWord(): string {
    return this.data?.confirmWord || "CONFIRM";
  }

  get isConfirmDisabled(): boolean {
    if (!this.data?.requireConfirmText) {
      return false; // gate not enabled, don't block existing dialogs
    }
    return (
      this.confirmText.trim().toUpperCase() !== this.confirmWord.toUpperCase()
    );
  }
}
